<div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="row">
  {{breadCrumb}}
</div>
<div class="row">
    <div class="col-md-4 leftFolderStructure" >
          <div class="scrollable-tree-container">
        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
            <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding (click)="openLeftSideGridFunc(node)" style="padding-left: 20px !important;">
              <button mat-icon-button disabled></button>
              <div style="display: flex;">
                <i class="fa fa-folder-open" style="margin-top: 7%;font-size:15px;color:#f1ca0ad1;padding-right:5px;"></i>
            </div>
            <span style="cursor: pointer;" [ngClass]="{ 'background-highlight': activeNode === node }">{{node.folderName}}</span>
            </mat-tree-node>
            <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding style="padding-left: 20px !important;" (click)="openLeftSideGridFunc(node)">
              <button mat-icon-button
                      [attr.aria-label]="'toggle ' + node.filename" matTreeNodeToggle>
                      <div style="display: flex;">
                        <i class="fa fa-folder-open" style="margin-top: 7%;font-size:15px;color:#f1ca0ad1;padding-right:5px;"></i>
                    </div>
              </button>
              <span style="cursor: pointer;" [ngClass]="{ 'background-highlight': activeNode === node }">{{node.folderName}}</span>
              <div class="page-loading-shade" *ngIf="node.isLoading">
                <app-custom-spinner *ngIf="node.isLoading"></app-custom-spinner>
              </div>
            </mat-tree-node>
          </mat-tree>
        </div>
    </div>
    <div class="col-md-8" [hidden]="!showDocumentsGrid">
      <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb" >
        <ol class="breadcrumb breadcrumb_bg">
          <li
            class="breadcrumb-item breamcrumb-text"
          >
            <span
              >{{ folderpath }}</span>
            
          </li>
        </ol>
      </nav>
      <div [hidden]="data != 'DISTRIBUTED'">
        <mat-radio-group aria-label="Select an option" [(ngModel)]="isDocumentAllOrIndividual" (change)="onTypeChanged(isDocumentAllOrIndividual)">
        <mat-radio-button value="All Documents" aria-checked="true">All Documents</mat-radio-button>
        <mat-radio-button value="Choose Document">Choose Document</mat-radio-button>
      </mat-radio-group>
      </div>
        <div class="menu-container">
          <div class="row menu-row-container">
              <div class="col-sm-6 gridName-container">
                  <span class="gridName">Documents</span>
                </div>
          
          </div>
          
        </div>
        <div class="table-container">
          <div id="header-container" class="d-flex justify-content-end gap-3 mt-1 mb-3">
              <div class="">
                  <div class="search-container">
                      <input type="text" class="form-control search_input" style="font-size: 13px;" placeholder="Search"
                          [(ngModel)]="searchValue" (input)="applyFilter2($event)">
                  </div>
              </div>
          </div>
        
          <table class="dynamic-table-container documentTable" style="overflow-y:scroll;max-height:380px;">
            <th [hidden]="isDocumentAllOrIndividual == 'All Documents' && data =='DISTRIBUTED'">
            <div style="display: flex;" *ngIf="data =='DOCUMENTFORDOWNLOAD'">
              <div>
                <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div style="margin-left: 5px;">
                <input type="checkbox" style="zoom: 1.2;" [checked]="parentCheckBox"
                  (change)="dataGridParentCheckBoxChecked($event)">
              </div>
            </div>
          </th>
              <th> 
              <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                <span>Document No.</span>
                <div class="d-flex gap-2 align-items-center">
                    <div>
                      <img
                        src="../../../assets/img/qms_img/sort.svg"
                        width="9px"
                        height="16px"
                        alt="sort"
                      />
                    </div>
                  </div>
                
            </div>
             </th>
             <th > 
              <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                <span>Version</span>
                <div class="d-flex gap-2 align-items-center">
                    <div>
                      <img
                        src="../../../assets/img/qms_img/sort.svg"
                        width="9px"
                        height="16px"
                        alt="sort"
                      />
                    </div>
                  </div>
                
            </div>
             </th>
             <th> 
              <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                <span>Name</span>
                <div class="d-flex gap-2 align-items-center">
                    <div>
                      <img
                        src="../../../assets/img/qms_img/sort.svg"
                        width="9px"
                        height="16px"
                        alt="sort"
                      />
                    </div>
                  </div>
                
            </div>
             </th>
             <th> 
              <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                <span>Document Type</span>
                <div class="d-flex gap-2 align-items-center">
                    <div>
                      <img
                        src="../../../assets/img/qms_img/sort.svg"
                        width="9px"
                        height="16px"
                        alt="sort"
                      />
                    </div>
                  </div>
                
            </div>
             </th><th > 
              <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                <span>Status</span>
                <div class="d-flex gap-2 align-items-center">
                    <div>
                      <img
                        src="../../../assets/img/qms_img/sort.svg"
                        width="9px"
                        height="16px"
                        alt="sort"
                      />
                    </div>
                  </div>
                
            </div>
             </th>
             
            <th  class="sticky-col first-col"></th>
              <!-- search input row is added -->
              <tr class="data-row-container" 
              *ngFor="let listOfDocumentsVwDetails of pagedItems | searchFilter : searchValue; let idx = index;">
              <td style="min-width: 80px; text-align: center;" [hidden]="isDocumentAllOrIndividual == 'All Documents' && data =='DISTRIBUTED'">
                <div style="display: flex;">
                  <div [ngClass]="listOfDocumentsVwDetails.searchDocumentChildCheckBoxs ?'static_icon':'hover-menu-icons'">
                    <i class="fa-solid fa-ellipsis-vertical"></i>
                  </div>
                  <div style="margin-left: 5px;">
                    <input id="selectedDocumentCheckBox" type="checkbox" style="zoom: 1.2;"
                      [checked]="listOfDocumentsVwDetails.searchDocumentChildCheckBoxs"
                      (change)="dataGridChildCheckBoxChecked($event, listOfDocumentsVwDetails, idx)">
                  </div>
                </div>
              </td>
              <td  class="row-data">{{ listOfDocumentsVwDetails.documentNo }}</td>
              <td  class="row-data">{{ listOfDocumentsVwDetails.version }}</td>
              <td class="row-data">{{ listOfDocumentsVwDetails.documentName }}</td>
              <td class="row-data">{{ listOfDocumentsVwDetails.documentTypeName }}</td>
              <td  class="row-data">{{ listOfDocumentsVwDetails.status }}</td>
            </tr>
            <tr *ngIf="documentsList.length == 0">
              <td [hidden]="isDocumentAllOrIndividual == 'All Documents'" colspan="4"><b>No Documents Found.</b></td>
              <td [hidden]="isDocumentAllOrIndividual != 'All Documents'" colspan="3"><b>No Documents Found.</b></td>
            </tr>
          </table>
          <div class="d-flex justify-content-center">
              <div class="width-cheat small paginationCell">
                <div class="d-flex align-items-center gap-3">
                  <div class="pagination_text mt-3">
                    {{ showingRowsText }}
                    1-{{ perPage }} of {{ collectionSize | number }}
                  </div>
                  <div>
                    <ngb-pagination
                      class="leftpadding"
                      (pageChange)="setPage(pager.currentPage, $event)"
                      [disabled]="false"
                      [collectionSize]="pager.totalItems"
                      [(page)]="pager.currentPage"
                      [maxSize]="maxSize"
                      [rotate]="true"
                      [pageSize]="perPage"
                      [ellipses]="false"
                      [boundaryLinks]="true"
                      size="sm"
                    >
                    </ngb-pagination>
                  </div>
                  <div ngbDropdown class="mt-3">
                    <button
                      class="btn btn-primary btn-sm mr-1 bg-white pagination_text"
                      id="dropdownBasic1"
                      ngbDropdownToggle
                    >
                      {{ perPage }}
                      <i class="ms-1 fa-solid fa-chevron-down"></i>
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                      <button ngbDropdownItem (click)="paginationCall(10)">10</button>
                      <button ngbDropdownItem (click)="paginationCall(20)">20</button>
                      <button ngbDropdownItem (click)="paginationCall(50)">50</button>
                    </div>
                    per page
                  </div>
                </div>
              </div>
            </div>
        
        </div>
    </div>
</div>
